import { useParams } from "react-router";
import ProfileActions from "./ProfileActions";
import { MdContactMail } from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import { userServices } from "../Services/userServices";
import { Button, Collapse, Form, ListGroup } from "react-bootstrap";

const Navbar = ({ openModule, setOpenModule, setShowSidebar, handleAddNewTab, setShowLUPModule }) => {
  const AppsRef = useRef(null);
  const { studyId } = useParams();
  const [image, setImage] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [AppsActive, setAppsActive] = useState(false);
  const roleType = JSON.parse(localStorage.getItem("role"));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setAppsActive(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const getGMTOffset = () => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const absMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
    const minutes = String(absMinutes % 60).padStart(2, '0');
    return `GMT${sign}${hours}:${minutes}`;
  }

  useEffect(() => {
    profileData();
  }, []);

  const permission = JSON.parse(localStorage.getItem("permissionData"));

  const profileData = async () => {
    const item2 = JSON.parse(localStorage.getItem("lastName"));
    const item1 = JSON.parse(localStorage.getItem("firstName"));
    if (item1) {
      setFirstName(item1);
    }
    if (item2) {
      setLastName(item2);
    }
  };

  const logout = async () => {
    await userServices.logout();
  };

  useEffect(() => {
    const currentDetails = async (e) => {
      let userData = await userServices.getCurrentUserDetails(e);
      setImage(userData?.[0]?.user_id?.image);
    };
    currentDetails();
  }, [studyId]);

  return (
    <>
      <div style={{ background: "var(--blue)" }}>
        <div className="hstack justify-content-between border-bottom border-secondary px-2 py-1">
          <h4 className="text-white m-0">Galax®</h4>
          <div className="hstack justify-content-between gap-2">
            <span className="text-white"><i className="fa-solid fa-earth-asia me-1 text-info"></i>Timezone: {getGMTOffset() || "NA"}</span>
            <span className="text-white"><i className="fa-solid fa-building-user me-1 text-info"></i>Logged in as :{" "}
              {roleType === "super_user" ? "Super Admin" : roleType === "devops" ? "DevOps" : "User"}
            </span>
            <div className="hstack gap-1">
              <ProfileActions
                handleAddNewTab={handleAddNewTab}
                ProfileImage={image}
                firstName={firstName}
                lastName={lastName}
              />
              <Button
                onClick={logout}
                variant="outline-danger"
                className="p-1 px-2 border-0 br3"
                style={{ fontSize: 13 }}
                title="Sign out from panel"
              >
                <i className="fa-solid fa-right-from-bracket me-1"></i>Signout
              </Button>
            </div>
          </div>
        </div>
        <div className="hstack justify-content-between filebar" style={{ height: 35, padding: 5 }}>
          <div className="hstack gap-2">
            <div ref={AppsRef}>
              {(roleType === "super_user" || roleType === "user" || roleType === "devops") &&
                <Button ref={AppsRef} className="position-relative border-0 py-1 px-2 text-start br3" variant="outline-light" onClick={() => setAppsActive(!AppsActive)}>
                  <div className="hstack gap-1">
                    <i className="fa-solid fa-grip me-1 text-info" style={{ fontSize: 14 }}></i>
                    <p className="m-0" style={{ fontSize: 13 }}>Apps</p>
                    <i className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`} style={{ fontSize: 12 }}></i>
                  </div>
                  <Collapse in={AppsActive}>
                    <div className="position-absolute start-0" style={{ top: 31, zIndex: 999 }}>
                      <ListGroup style={{ fontSize: 12, width: "max-content" }}>
                        <ListGroup.Item action onClick={() => { setOpenModule("clients"); setShowSidebar(true) }} title="Clients Management">
                          <i className={`fa-solid fa-building-user me-2`}></i>Clients Management
                        </ListGroup.Item>
                        {(roleType === "super_user" || permission?.userManagementAccess) &&
                          <ListGroup.Item action onClick={() => { setOpenModule("users"); setShowSidebar(true) }} title="Users Management">
                            <i className={`fa-solid fa-users me-2`}></i>Users Management
                          </ListGroup.Item>
                        }
                        {(roleType === "super_user" || permission?.globalFormManagementAccess) &&
                          <ListGroup.Item action onClick={() => { setOpenModule("globalLibrary"); setShowSidebar(true) }}>
                            <i className={`fa-solid fa-building-lock me-2`}></i>Global Form Library
                          </ListGroup.Item>
                        }
                        {(roleType === "super_user" || permission?.etmfFormManagementAccess) &&
                          <ListGroup.Item action onClick={() => { setOpenModule("etmf"); setShowSidebar(true) }} title="eTMF Management">
                            <i className={`fa-solid fa-book-open me-2`}></i>eTMF Management
                          </ListGroup.Item>
                        }
                        {(roleType === "super_user" || permission?.developerforLUPAccess || permission?.validatorforLUPAccess) &&
                          <>
                            <ListGroup.Item action onClick={() => { setOpenModule("lup"); setShowSidebar(true) }} title="LUP Management">
                              <i className={`fa-solid fa-laptop me-2`}></i>LUP Management
                            </ListGroup.Item>
                            <ListGroup.Item action onClick={() => { setOpenModule("lupFileManagement"); setShowSidebar(true) }} title="File Management">
                              <i className={`fa-solid fa-desktop me-2`}></i>File Management
                            </ListGroup.Item>
                          </>
                        }
                        <ListGroup.Item action onClick={() => { setOpenModule("recipient"); setShowSidebar(true) }} title="BD Management">
                          <MdContactMail className="me-1" style={{width: 15, height: 15}} /> BD Management
                        </ListGroup.Item>
                        {(roleType === "super_user" || permission?.cdiscManagementAccess) &&
                          <ListGroup.Item action onClick={() => { setOpenModule("cdisc"); setShowSidebar(true) }} title="CDISC Management">
                            <i className={`fa-solid fa-laptop-code me-2`}></i>CDISC Management
                          </ListGroup.Item>
                        }
                        {(roleType === "super_user" || permission?.seftyDatabaseManagementAccess) &&
                          <ListGroup.Item action onClick={() => { setOpenModule("seftyDatabase"); setShowSidebar(true) }} title="Sefty Database Management">
                            <i className={`fa-solid fa-database me-2`}></i>Sefty Database Management
                          </ListGroup.Item>
                        }
                        <ListGroup.Item action onClick={() => { setOpenModule("logs"); setShowSidebar(true) }} title="Logs Management">
                          <i className={`fa-solid fa-clock-rotate-left me-2`}></i>Logs Management
                        </ListGroup.Item>
                      </ListGroup>
                    </div>
                  </Collapse>
                </Button>
              }
            </div>
            <div>
              {((permission?.developerforLUPAccess || permission?.validatorforLUPAccess) && openModule === "lup") &&
                <Form.Select className="border-0" onChange={(e) => setShowLUPModule(e.target.value)}>
                  <option value="packages">Packages</option>
                  <option value="libraries">Libraries</option>
                  <option value="settings">Settings</option>
                </Form.Select>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
